module.exports = __webpack_public_path__ + "static/img/200317.3ceb1fcd.png";